import React, { useState } from 'react'
// import { useDispatch } from 'react-redux'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import AttachFilesPDPAForm from './AttachFilesPDPAForm'

export default function AttachFilesPDPAWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, loadMenu, formDisabled, header } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)

  // const dispatch = useDispatch()
  // const { projectId } = useParams()

  const handleDelete = () => {
    console.log('handleDelete')
  }

  const onDownload = () => {
    console.log('onDownload')
  }

  const onPreview = () => {
    console.log('onPreview')
  }

  const handleOnUploadSuccess = () => {
    console.log('handleOnUploadSuccess')
  }

  return (
    <Panel
      shaded
      header={header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      <AttachFilesPDPAForm
        schema={formSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        onDelete={handleDelete}
        onDownload={onDownload}
        onPreview={onPreview}
        onUploadSuccess={(e) => handleOnUploadSuccess(e)}
        isEditErr={isEditErr}
        isUploadErr={isUploadErr}
        isDeleteError={isDeleteError}
        loading={isLoading}
        disabledForm={formDisabled}
      />
    </Panel>
  )
}
